module.exports = __webpack_public_path__ + "static/img/5.268a89e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/ck/5.jpg
// module id = pd9j
// module chunks = 1